import { Injectable } from '@angular/core';
import { IDropdownData } from '../models/dropdownData.model';

@Injectable()
export class UtilService {

    public getCountryDropdownData(): IDropdownData[] {
        const ret: IDropdownData[] = [];
        ret.push({ value: "BR", label: "Brazil"});
        ret.push({ value: "PT", label: "Portugal"});
        ret.push({ value: "US", label: "United States"});
        return ret;
    }  
}
